import { connect } from 'react-redux';

import User from 'models/User';

import { State as StoreState } from 'store/state';

import Component from './component';

export interface Props extends ParentProps {
	state: {
		authToken?: string;
		profile?: User;
	};
}

export interface ParentProps {}

const mapStateToProps = (state: StoreState, ownProps?: Props): object => {
    return {
        state: {
            authToken: state.user.authToken,
            profile: state.user.profile,
        },
    };
};

Component.defaultProps = {};
export default connect(mapStateToProps)(Component);
